import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../lib/api";

/**
 * Owner Dashboard — Lead Pipeline summary card.
 * Five counters that turn incoming interest into a manageable funnel view.
 * Clicking anywhere on the card opens the full Leads page.
 */
export function LeadPipelineCard() {
  const nav = useNavigate();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get("/admin/leads/pipeline");
        setData(r.data);
      } catch (e) {
        setErr(e?.response?.data?.detail || "Failed to load pipeline");
      }
    })();
  }, []);

  const cells = [
    { key: "new_leads",          label: "New leads",          filter: "new" },
    { key: "reports_sent_today", label: "Reports sent today", filter: "all" },
    { key: "trials_started",     label: "Trials started",     filter: "trial" },
    { key: "customers",          label: "Paying customers",   filter: "customer" },
    { key: "needs_followup",     label: "Needs follow-up",    filter: "needs_followup", tone: "amber" },
  ];

  return (
    <div className="rounded-2xl bg-white border border-black/5 shadow-soft p-6" data-testid="lead-pipeline-card">
      <div className="flex items-center justify-between mb-4">
        <div>
          <p className="text-[10px] font-mono uppercase tracking-widest text-charcoal-400">Lead pipeline</p>
          <h3 className="mt-1 text-lg font-medium text-charcoal-900">Command center</h3>
          <p className="text-xs text-charcoal-500 mt-0.5">Free report → trial → customer journey</p>
        </div>
        <div className="flex items-center gap-2">
          <button onClick={() => nav("/admin/prospect-scan")}
                  data-testid="lead-pipeline-prospect-btn"
                  className="inline-flex items-center gap-1 px-3 py-1 rounded-full border border-black/10 bg-white text-[11px] font-mono uppercase tracking-widest text-charcoal-700 hover:border-black/20">
            + Prospect Scan
          </button>
          <button onClick={() => nav("/admin/leads")}
                  data-testid="lead-pipeline-open-btn"
                  className="text-xs font-mono uppercase tracking-widest text-charcoal-500 hover:text-charcoal-900">
            Open leads →
          </button>
        </div>
      </div>
      {err ? (
        <p className="text-sm text-red-600">{err}</p>
      ) : !data ? (
        <p className="text-sm text-charcoal-400">Loading…</p>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-5 gap-3">
          {cells.map((c) => (
            <button key={c.key}
                    onClick={() => nav(`/admin/leads?filter=${c.filter}`)}
                    data-testid={`pipeline-${c.filter}`}
                    className="text-left rounded-xl border border-black/5 bg-charcoal-50/40 hover:bg-charcoal-50 px-3 py-3 transition">
              <p className={`text-2xl font-semibold tracking-tighter ${c.tone === 'amber' && data[c.key] > 0 ? 'text-amber-700' : 'text-charcoal-900'}`}>{data[c.key]}</p>
              <p className="text-[10.5px] font-mono uppercase tracking-widest text-charcoal-500 mt-1">{c.label}</p>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default LeadPipelineCard;
